var _circle, _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgCuredLogoCircleGreenNoText = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 20,
    cy: 20,
    r: 19.5,
    fill: "#009C70",
    stroke: "#AFEDDE"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M27.098 25.625a1.042 1.042 0 00-1.474 0 7.796 7.796 0 01-5.581 2.29 7.944 7.944 0 01-5.616-2.349c-3.102-3.103-3.129-8.126-.057-11.196 3.07-3.072 8.094-3.045 11.197.058a1.04 1.04 0 001.474 0 1.042 1.042 0 000-1.474c-3.916-3.916-10.261-3.942-14.145-.058-3.884 3.883-3.858 10.228.057 14.144l.001.001A10.02 10.02 0 0020.034 30h.047a9.854 9.854 0 007.019-2.9 1.045 1.045 0 00-.002-1.475z",
    fill: "#FFFEEE"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M28.217 24.675a1.042 1.042 0 01-.955-1.458 7.94 7.94 0 00-.037-6.373 1.042 1.042 0 111.905-.847 10.03 10.03 0 01.044 8.052c-.17.392-.554.627-.957.627z",
    fill: "#13D6B0"
  })));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgCuredLogoCircleGreenNoText);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/cured-logo-circle-green-no-text.7010e7b4d097019affc5d4bd3a870bba.svg";